<div class="appWrapper">
   <header class="appHeader">
      <div class="contentBox flex hr-space-between">
         <a routerLink="/home" class="logoMain flex">
            <div class="logo icon">
<!--               <img src="assets/images/logo.png" alt="" class="whiteLogo">-->
               <img src="assets/images/logoBlack.png" alt="" class="whiteLogo">
               <img src="assets/images/logoBlack.png" alt="" class="blackLogo">
            </div>
            <div class="margin-l-10 logoTxt">MISSION HOLDINGS</div>
         </a>

         <div class="appNav">
            <nav class="flex font-14 proximaNovaSb">
               <div class="navBox">
                  <a class="" routerLink="/about-mission" id="aboutMenu"
                     [ngClass]="{'active': path?.currentRout('about-mission')}">About Mission</a>
               </div>
               <div class="navBox">
                  <a class="parentMenu" routerLink="/team/saurabh-mittal"
                     [ngClass]="{'active': path?.currentRout('team')}">
                     Our Team
                  </a>
                  <ul class="subNav">
                     <li>
                        <a routerLink="/team/saurabh-mittal">Saurabh Mittal</a>
                     </li>
                     <li>
                        <a routerLink="/team/leadership">Leadership</a>
                     </li>
                     <li>
                        <a routerLink="/team/investment">Investment Team</a>
                     </li>
                  </ul>
               </div>
               <div class="navBox">
                  <a class="parentMenu" routerLink="/capitals/platform-services" href="" id="capitalMenu"
                     [ngClass]="{'active': path?.currentRout('capitals')}">
                     Our Platforms
                  </a>
                  <ul class="subNav">
                     <li>
                        <a routerLink="/capitals/platform-services">Software & Services</a>
                     </li>
                     <li>
                        <a routerLink="/capitals/asset">Asset Management</a>
                     </li>
                     <li>
                        <a routerLink="/capitals/fintech">FinTech</a>
                     </li>
                     <li>
                        <a routerLink="/capitals/sports">Sports</a>
                     </li>
                     <li>
                        <a routerLink="/capitals/details">Mission Capital</a>
                     </li>
                  </ul>
               </div>
               <!-- <div class="navBox">
                  <a class="" routerLink="/missionCapital/details" href=""
                     [ngClass]="{'active': path?.currentRout('missionCapital')}">Mission Capital</a>
                  <ul class="subNav">
                     <li>
                        <a routerLink="/missionCapital/details">Mission Capital</a>
                     </li>
                     <li>
                        <a routerLink="/missionCapital/looking-for">What We Look For</a>
                     </li>
                     <li>
                        <a routerLink="/missionCapital/capital-investment">Our Investments</a>
                     </li>
                  </ul>
               </div> -->
               <div class="navBox">
                  <a class="" routerLink="/philanthropy" href=""
                     [ngClass]="{'active': path?.currentRout('philanthropy')}">Philanthropy</a>
               </div>
               <div class="navBox">
                  <a class="" routerLink="/news" href=""
                     [ngClass]="{'active': path?.currentRout('news')}">News & Media</a>
               </div>
               <!--               <div class="navBox">-->
               <!--                  <a class="singleLink"  routerLink="/contact"-->
               <!--                     [ngClass]="{'active': path?.currentRout('contact')}">Contact</a>-->
               <!--               </div>-->
            </nav>

         </div>

         <ul class="appMenuBtn">
            <li class="top"></li>
            <li class="mid"></li>
            <li class="low"></li>
         </ul>

      </div>
   </header>

   <div class="menuSec">
      <div class="menuCont">
         <ul class="menuList subNormal">
            <li class="footerNav proximaNovaSb">
               <a class="" routerLink="/about-mission"
                  [ngClass]="{'active': path?.currentRout('about-mission')}">About Mission</a>
            </li>
            <li class="footerNav">
               <div class="menuHeading proximaNovaSb">
                  <a class="" routerLink="/team/saurabh-mittal"
                     [ngClass]="{'highlight-color': path?.currentRout('team')}">Our Team</a>
               </div>
               <div class="">
                  <a routerLink="/team/saurabh-mittal">Saurabh Mittal</a>
               </div>
               <div class="">
                  <a routerLink="/team/leadership">Leadership</a>
               </div>
               <div class="">
                  <a routerLink="/team/investment">Investment Team</a>
               </div>
            </li>
            <li class="footerNav">
               <div class="menuHeading proximaNovaSb">
                  <a class="" routerLink="/capitals/platform-services"
                     [ngClass]="{'highlight-color': path?.currentRout('capitals')}">Our Businesses</a>
               </div>
               <div class="">
                  <a routerLink="/capitals/platform-services">Software & Services</a>
               </div>
               <div class="">
                  <a routerLink="/capitals/sports">Sports</a>
               </div>
               <div class="">
                  <a routerLink="/capitals/fintech">FinTech</a>
               </div>
               <div class="">
                  <a routerLink="/capitals/asset">Asset Management</a>
               </div>
            </li>
            <li class="footerNav">
               <div class="menuHeading proximaNovaSb">
                  <a class="" routerLink="/missionCapital/details" href=""
                     [ngClass]="{'highlight-color': path?.currentRout('missionCapital')}">Mission Capital</a>
               </div>
               <div>
                  <a routerLink="/missionCapital/details">Mission Capital</a>
               </div>
               <div>
                  <a routerLink="/missionCapital/looking-for">What We Look For</a>
               </div>
               <div>
                  <a routerLink="/missionCapital/capital-investment">Our Investments</a>
               </div>
            </li>
            <li class="footerNav proximaNovaSb">
               <a class="parentMenu" routerLink="/philanthropy" href=""
                  [ngClass]="{'active': path?.currentRout('philanthropy')}">Philanthropy</a>
            </li>
            <li class="footerNav proximaNovaSb">
               <a class="parentMenu" routerLink="/news" href=""
                  [ngClass]="{'active': path?.currentRout('news')}">News & Media</a>
            </li>
         </ul>
         <!--         <ul class="menuList">-->
         <!--            <li class="footerNav">-->
         <!--               <div class="menuHeading proximaNovaSb">-->
         <!--                  About-->
         <!--               </div>-->
         <!--               <div class="">-->
         <!--                  <a routerLink="/about">Overview</a>-->
         <!--               </div>-->
         <!--               <div class="">-->
         <!--                  <a href="">Mission Statement</a>-->
         <!--               </div>-->
         <!--               <div class="">-->
         <!--                  <a href="">Investment Philosophy</a>-->
         <!--               </div>-->
         <!--            </li>-->
         <!--            <li class="footerNav">-->
         <!--               <div class="menuHeading proximaNovaSb">-->
         <!--                  Leadership & Team-->
         <!--               </div>-->
         <!--               <div class="">-->
         <!--                  <a href="" routerLink="/leadership">Team Mission</a>-->
         <!--               </div>-->
         <!--               <div class="">-->
         <!--                  <a href="" routerLink="/leadership">Our Entrepreneurs</a>-->
         <!--               </div>-->
         <!--            </li>-->
         <!--            <li class="footerNav">-->
         <!--               <div class="menuHeading proximaNovaSb">-->
         <!--                  Mission Holdings Capital-->
         <!--               </div>-->
         <!--               <div class="">-->
         <!--                  <a href="" routerLink="/capitals">Investments</a>-->
         <!--               </div>-->
         <!--               <div class="">-->
         <!--                  <a href="" routerLink="/capitals">Holding Companies</a>-->
         <!--               </div>-->
         <!--            </li>-->
         <!--            <li class="footerNav">-->
         <!--               <div class="menuHeading proximaNovaSb">-->
         <!--                  Philanthropy-->
         <!--               </div>-->
         <!--               <div class="">-->
         <!--                  <a href="" routerLink="/philanthropy">Charity</a>-->
         <!--               </div>-->
         <!--               <div class="">-->
         <!--                  <a href="" routerLink="/philanthropy">Endowments</a>-->
         <!--               </div>-->
         <!--            </li>-->
         <!--            <li class="footerNav">-->
         <!--               <div class="proximaNovaSb">-->
         <!--                  <a href="" routerLink="/contact">Contact</a>-->
         <!--               </div>-->
         <!--            </li>-->
         <!--         </ul>-->
      </div>
   </div>

   <router-outlet></router-outlet>

   <footer class="pageSection font-15 parallaxBlock">
      <div class="contentBox">
         <div class="footer-links-sec flex hr-space-between align-top margin-b-50">
            <a routerLink="/home" class="footerLogo block icon padding-b-5">
               <img src="assets/images/logo.png" alt="">
            </a>
            <ul class="footerLinks flex flex-wrap align-top">
               <li class="footerNav">
                  <div class="proximaNovaSb margin-b-20">Contact</div>
                  <div class="">
                     To get in touch with<br>
                     Mission Holdings,
                     please email<br>
                     <div class="margin-t-10">
                        <a class="highlight-color" href="mailto:inquiries@missionholdings.com">inquiries@missionholdings.com</a>
                     </div>
                  </div>
               </li>
               <li class="footerNav">
                  <div class="proximaNovaSb margin-b-20">Locations</div>
                  <div class="margin-b-20 light-color">Singapore</div>
                  <div class="margin-b-20 light-color">New York</div>
                  <div class=" light-color">India</div>
               </li>
               <li class="footerNav">
                  <div class="proximaNovaSb margin-b-20">Social Media</div>
                  <div class="margin-b-20">
                     <a class="" href="https://at.linkedin.com/company/mission-holdings" target="_blank">LinkedIn</a>
                  </div>
                  <!-- <div class="">
                     <a class="" href="https://twitter.com/MissionHoldings" target="_blank">Twitter</a>
                  </div> -->
               </li>
            </ul>
         </div>

         <div class="copyRightSec flex hr-space-between align-end">
            <div class=" width-block-50">
               <div class="proximaNovaSb margin-b-10">Mission Holdings - Head Office Address:</div>
               <div class="">163 Penang Rd #08-00 Winsland Hse II Singapore 238463</div>
            </div>

            <div class="copyRightTxt width-block-50 text-align-right">Copyright Mission Holdings {{year}}. All Rights
               Reserved
            </div>
            <!--            <div class="flex countries lightColor">-->
            <!--               <div class="flex">-->
            <!--                  <div class="icon">-->
            <!--                     <img src="assets/images/singapore.png" alt="">-->
            <!--                  </div>-->
            <!--                  <a href="" class="margin-l-10">Singapore</a>-->
            <!--               </div>-->
            <!--               <div class="flex margin-l-30">-->
            <!--                  <div class="icon">-->
            <!--                     <img src="assets/images/sanFrancisco.png" alt="">-->
            <!--                  </div>-->
            <!--                  <a href="" class="margin-l-10">San Francisco</a>-->
            <!--               </div>-->
            <!--               <div class="flex margin-l-30">-->
            <!--                  <div class="icon">-->
            <!--                     <img src="assets/images/india.png" alt="">-->
            <!--                  </div>-->
            <!--                  <a href="" class="margin-l-10">India</a>-->
            <!--               </div>-->
            <!--            </div>-->
         </div>
      </div>
   </footer>
</div>

